export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7898.64663b31.jpg";